import { Schema } from "effect";

export const AgentAccountingBoundaryParseOptions = {
  errors: "all",
  onExcessProperty: "error",
  reportInput: false,
} as const;

const NonNegativeSafeIntegerSchema = Schema.Int.check(
  Schema.isGreaterThanOrEqualTo(0),
  Schema.isLessThanOrEqualTo(Number.MAX_SAFE_INTEGER),
);

const ModelAliasSchema = Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(160));

const AgentMessageTokenUsageFields = {
  inputTokens: NonNegativeSafeIntegerSchema,
  outputTokens: NonNegativeSafeIntegerSchema,
  totalTokens: NonNegativeSafeIntegerSchema,
  cacheReadTokens: NonNegativeSafeIntegerSchema,
  cacheWriteTokens: NonNegativeSafeIntegerSchema,
  reasoningTokens: NonNegativeSafeIntegerSchema,
  modelCallCount: NonNegativeSafeIntegerSchema,
} as const;

/** Project message metadata is token-only; monetary authority belongs to internal ledgers. */
export const AgentMessageUsageSchema = Schema.Struct(AgentMessageTokenUsageFields);

export const AgentMessageMetadataSchema = Schema.Struct({
  version: Schema.Literal("agent-message-metadata/v1"),
  model: ModelAliasSchema,
  usage: AgentMessageUsageSchema,
});

export const AgentMessageMetadataStandardSchema = Schema.toStandardSchemaV1(
  Schema.UndefinedOr(AgentMessageMetadataSchema),
  { parseOptions: AgentAccountingBoundaryParseOptions },
);

export const decodeAgentMessageMetadata = Schema.decodeUnknownSync(
  AgentMessageMetadataSchema,
  AgentAccountingBoundaryParseOptions,
);

export const encodeAgentMessageMetadata = Schema.encodeSync(
  AgentMessageMetadataSchema,
  AgentAccountingBoundaryParseOptions,
);

export type AgentMessageUsage = typeof AgentMessageUsageSchema.Type;
export type AgentMessageMetadata = typeof AgentMessageMetadataSchema.Type;
